module.exports = __webpack_public_path__ + "img/dex-storage-home.c3336a50.jpg";